export default class BaseUrlManager {
    constructor(list = {}) {
        this.urls = list;
    }
    to(request) {
        if (typeof this.urls[request] === 'undefined') {
            throw new Error(`${request}: Appropriate URL was not found.`);
        }

        return this.urls[request];
    }
}
